import script from "./CobrosView.vue?vue&type=script&setup=true&lang=js"
export * from "./CobrosView.vue?vue&type=script&setup=true&lang=js"

import "./CobrosView.vue?vue&type=style&index=0&id=84bc8908&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84bc8908"]])

export default __exports__